import React from 'react';
import { Box, Button } from "@mui/material";
import ActionFooter from '../../../Shared/ActionFooter/ActionFooter';
import locationImage from '../../../../assets/images/location/location.png';

const InspectionLocationNative = (props: any) => {
  const {
    shareLocation,
    continueWithoutSharing,
  } = props;

  return (
    <Box
      component="div"
      className="inspection"
      sx={{
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <Box
        sx={{
          margin: '0 20px',
          width: '-webkit-fill-available',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div style={{
          color: '#D40020',
          fontSize: '12px',
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontWeight: 500,
          marginTop: '30px'
        }}>2 de 2</div>
        <div
          className="title"
          style={{
            width: '100%',
            textAlign: 'center',
          }}
        >Ative a localização do aparelho</div>
        <div className="description">
          Isso é necessário para evitar fraudes e<br />
          tornar o processo da vistoria mais seguro
        </div>
        <img
          src={locationImage}
          alt="location-indicator"
          className="ilustration"
          data-testid='location-image'
        />
      </Box>
      <ActionFooter>
        <Button
          fullWidth
          variant="contained"
          onClick={() => { shareLocation() }}
          data-testid="btn-share-location"
          sx={{
            fontFamily: 'Poppins !important',
            background: '#111 !important',
            borderRadius: '100px !important',
            textTransform: 'none !important',
            letterSpacing: '0.1px !important',
            color: '#EFEFEF !important',
            fontWeight: '600 !important',
            fontSize: '14px !important',
            lineHeight: '20px !important',
            padding: '10px !important',
            boxShadow: 'none !important',
          }}
        >Compartilhar a localização</Button>
        <Button
          fullWidth
          variant="outlined"
          className="secondary-button"
          onClick={() => { continueWithoutSharing() }}
          data-testid="btn-skip-location"
          sx={{ textTransform: 'none !important' }}
        >Continuar sem compartilhar</Button>
      </ActionFooter>
    </Box>
  );
};

export default InspectionLocationNative;
